import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import FormSendRequest from "../forms/FormSendRequest";

function SendRequest(props) {
  const history = useHistory();

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  return (
    <main className="sendrequest">
      <h1 className="title">Anfrage senden</h1>
      <p className="info">Sollten Sie weitere Lizenzen für den Kompetenzcheck21 benötigen, können Sie über das Formular direkt mit Ihrem zuständigen Ansprechpartner Kontakt aufnehmen.</p>
      <FormSendRequest
        onCancel={e => {
          history.push("/");
        }}
      />
    </main>
  );
}
export default SendRequest;
